import React from 'react';
import { bool, func, string } from 'prop-types';

// Components
import CheckboxRoundedIcon from '@mui/icons-material/CheckBoxRounded';
import { Checkbox, FormControlLabel, Typography } from '@mui/material';

const WizardCheckbox = ({ checked, disabled, onChange, name }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          checkedIcon={<CheckboxRoundedIcon sx={{ color: 'secondary.main' }} />}
          disabled={disabled}
          name={name}
          onChange={onChange}
        />
      }
      label={
        <Typography
          sx={{
            '&.MuiTypography-root': {
              color: disabled ? 'palette.text.disabled' : 'palette.text.primary',
              mx: 1,
            },
          }}
          variant="body1"
        >
          {name}
        </Typography>
      }
      sx={{
        color: 'text.secondary',
        height: 42,
        mx: 0,
        width: '100%',
      }}
    />
  );
};

WizardCheckbox.propTypes = {
  checked: bool,
  disabled: bool,
  name: string.isRequired,
  onChange: func.isRequired,
};

WizardCheckbox.defaultProps = {
  checked: false,
  disabled: false,
};

export default WizardCheckbox;
